import * as React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import LinkArrowIcon from 'assets/icons/arrows/arrow-alt2-16.svg';

import { COLORS } from 'styles/style-constants';

const styles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${COLORS.purple500};
    font-size: 1.6rem;
    line-height: 2.8rem;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;
`;

const LinkBody = styled.a`
    ${styles};
`;

const LinkStyled = styled(Link)`
    ${styles};
`;

const LinkBodyDiv = styled.div`
    ${styles};

    a {
        text-decoration: none;
    }
`;

const LinkArrow = styled(LinkArrowIcon)`
    margin-left: 1rem;

    path {
        fill: ${COLORS.purple500};
    }
`;

interface ExternalLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement & HTMLDivElement> {
    children: string | React.ReactNode;
    endIcon?: React.ReactNode;
    asDiv?: boolean;
    to?: string;
}

const ExternalLink = ({
    children,
    asDiv,
    to,
    endIcon,
    ...props
}: ExternalLinkProps): React.ReactNode => {
    if (asDiv) {
        return (
            <LinkBodyDiv {...props}>
                {children}
                {endIcon ?? <LinkArrow />}
            </LinkBodyDiv>
        );
    }

    if (to) {
        return (
            <LinkStyled to={to} {...props}>
                {children}
                {endIcon ?? <LinkArrow />}
            </LinkStyled>
        );
    }

    return (
        <LinkBody {...props} target="_blank" rel="noreferrer noopener">
            {children}
            {endIcon ?? <LinkArrow />}
        </LinkBody>
    );
};

export default ExternalLink;
